import "esbuild-css-modules-plugin-ns-css:src/avatar-selection-ui/components/AvatarPanel/AvatarSelectionUIComponent.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/avatar-selection-ui/components/AvatarPanel/AvatarSelectionUIComponent.module.css:injector.js";
export default new Proxy({
  "avatarSelectionContainer": "AvatarSelectionUIComponent-module__avatarSelectionContainer_VjZ7cq__0190",
  "avatarSelectionUi": "AvatarSelectionUIComponent-module__avatarSelectionUi_VjZ7cq__0190",
  "avatarSelectionUiAvatar": "AvatarSelectionUIComponent-module__avatarSelectionUiAvatar_VjZ7cq__0190",
  "avatarSelectionUiAvatarImgContainer": "AvatarSelectionUIComponent-module__avatarSelectionUiAvatarImgContainer_VjZ7cq__0190",
  "avatarSelectionUiCloseButton": "AvatarSelectionUIComponent-module__avatarSelectionUiCloseButton_VjZ7cq__0190",
  "avatarSelectionUiContent": "AvatarSelectionUIComponent-module__avatarSelectionUiContent_VjZ7cq__0190",
  "avatarSelectionUiHeader": "AvatarSelectionUIComponent-module__avatarSelectionUiHeader_VjZ7cq__0190",
  "avatarTab": "AvatarSelectionUIComponent-module__avatarTab_VjZ7cq__0190",
  "closeButton": "AvatarSelectionUIComponent-module__closeButton_VjZ7cq__0190",
  "confirmButtons": "AvatarSelectionUIComponent-module__confirmButtons_VjZ7cq__0190",
  "confirmContainer": "AvatarSelectionUIComponent-module__confirmContainer_VjZ7cq__0190",
  "confirmDesc": "AvatarSelectionUIComponent-module__confirmDesc_VjZ7cq__0190",
  "customAvatarInput": "AvatarSelectionUIComponent-module__customAvatarInput_VjZ7cq__0190",
  "customAvatarInputSection": "AvatarSelectionUIComponent-module__customAvatarInputSection_VjZ7cq__0190",
  "customAvatarSection": "AvatarSelectionUIComponent-module__customAvatarSection_VjZ7cq__0190",
  "guideBox": "AvatarSelectionUIComponent-module__guideBox_VjZ7cq__0190",
  "guideCol": "AvatarSelectionUIComponent-module__guideCol_VjZ7cq__0190",
  "guideKey": "AvatarSelectionUIComponent-module__guideKey_VjZ7cq__0190",
  "guideMouse": "AvatarSelectionUIComponent-module__guideMouse_VjZ7cq__0190",
  "guideRow": "AvatarSelectionUIComponent-module__guideRow_VjZ7cq__0190",
  "guideTab": "AvatarSelectionUIComponent-module__guideTab_VjZ7cq__0190",
  "inscription": "AvatarSelectionUIComponent-module__inscription_VjZ7cq__0190",
  "inscriptionSel": "AvatarSelectionUIComponent-module__inscriptionSel_VjZ7cq__0190",
  "logoutTab": "AvatarSelectionUIComponent-module__logoutTab_VjZ7cq__0190",
  "menuButton": "AvatarSelectionUIComponent-module__menuButton_VjZ7cq__0190",
  "moveAvatar": "AvatarSelectionUIComponent-module__moveAvatar_VjZ7cq__0190",
  "moveLogout": "AvatarSelectionUIComponent-module__moveLogout_VjZ7cq__0190",
  "moveName": "AvatarSelectionUIComponent-module__moveName_VjZ7cq__0190",
  "moveParcel": "AvatarSelectionUIComponent-module__moveParcel_VjZ7cq__0190",
  "moveTabs": "AvatarSelectionUIComponent-module__moveTabs_VjZ7cq__0190",
  "moveWearable": "AvatarSelectionUIComponent-module__moveWearable_VjZ7cq__0190",
  "nameField": "AvatarSelectionUIComponent-module__nameField_VjZ7cq__0190",
  "nameTab": "AvatarSelectionUIComponent-module__nameTab_VjZ7cq__0190",
  "none": "AvatarSelectionUIComponent-module__none_VjZ7cq__0190",
  "openTab": "AvatarSelectionUIComponent-module__openTab_VjZ7cq__0190",
  "parcelBox": "AvatarSelectionUIComponent-module__parcelBox_VjZ7cq__0190",
  "parcelButtons": "AvatarSelectionUIComponent-module__parcelButtons_VjZ7cq__0190",
  "parcelDetails": "AvatarSelectionUIComponent-module__parcelDetails_VjZ7cq__0190",
  "parcelEditorUi": "AvatarSelectionUIComponent-module__parcelEditorUi_VjZ7cq__0190",
  "parcelFlex": "AvatarSelectionUIComponent-module__parcelFlex_VjZ7cq__0190",
  "parcelInfo": "AvatarSelectionUIComponent-module__parcelInfo_VjZ7cq__0190",
  "parcelInput": "AvatarSelectionUIComponent-module__parcelInput_VjZ7cq__0190",
  "parcelSel": "AvatarSelectionUIComponent-module__parcelSel_VjZ7cq__0190",
  "parcelTab": "AvatarSelectionUIComponent-module__parcelTab_VjZ7cq__0190",
  "parcelTextInput": "AvatarSelectionUIComponent-module__parcelTextInput_VjZ7cq__0190",
  "parcelThumbnail": "AvatarSelectionUIComponent-module__parcelThumbnail_VjZ7cq__0190",
  "rotate": "AvatarSelectionUIComponent-module__rotate_VjZ7cq__0190",
  "rotation": "AvatarSelectionUIComponent-module__rotation_VjZ7cq__0190",
  "sectionHeading": "AvatarSelectionUIComponent-module__sectionHeading_VjZ7cq__0190",
  "selectedPill": "AvatarSelectionUIComponent-module__selectedPill_VjZ7cq__0190",
  "tabs": "AvatarSelectionUIComponent-module__tabs_VjZ7cq__0190",
  "tabsBox": "AvatarSelectionUIComponent-module__tabsBox_VjZ7cq__0190",
  "tooltipText": "AvatarSelectionUIComponent-module__tooltipText_VjZ7cq__0190",
  "wearableTab": "AvatarSelectionUIComponent-module__wearableTab_VjZ7cq__0190"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      